export const TRACKED_OTAS = ['Direct Rates', 'Booking.com', 'Expedia', 'Agoda'] as const;
export type TrackedOTA = (typeof TRACKED_OTAS)[number];

export const OTA_CSV_ALIASES: Record<TrackedOTA, string[]> = {
  'Direct Rates': ['official hotel', 'official', 'brand', 'direct'],
  'Booking.com': ['booking.com', 'booking'],
  Expedia: ['expedia'],
  Agoda: ['agoda'],
};

export const OTA_COLORS: Record<TrackedOTA, string> = {
  'Direct Rates': '#2c3e50',
  'Booking.com': '#003580',
  Expedia: '#F5A623',
  Agoda: '#5542F6',
};

export const LE_COLUMN_PATTERNS = ['luxury', 'luxuryescapes', 'luxury escapes'];

export const MIN_DATA_COVERAGE = 0.1;

export type SeverityLevel = 'in_parity' | 'slight' | 'moderate' | 'severe' | 'no_data' | 'no_comparison';

export interface DailyRow {
  date: string;
  lePrice: number | null;
  bestCompetitor: string | null;
  bestCompetitorPrice: number | null;
  priceDiff: number | null;
  priceDiffPct: number | null;
  severity: SeverityLevel;
  allPrices: Record<string, number>;
}

export interface DateRange {
  startDate: string;
  endDate: string;
  numDays: number;
  avgLePrice: number;
  avgCompetitorPrice: number;
  avgDiffPct: number;
  competitor: string;
  severity: SeverityLevel;
}

export interface OtaChartData {
  name: TrackedOTA;
  color: string;
  cheapestCount: number;
  availableCount: number;
  totalDates: number;
  data: Array<{ date: string; lePrice: number | null; otaPrice: number | null }>;
}

export interface RevenueHooks {
  totalImpressions: string;
  impressionsOutOfParity: string;
  outOfParityPct: number;
  cvrOutOfParity: string;
  cvrAtParity: string;
  cvrImprovementPct: string;
  actualOrders30d: number;
  actualRevenue30d: string;
  avgOrderValue: string;
  estimatedExtraRevenueMonthly: string;
  estimatedExtraRevenueAnnual: string;
}

export interface ParityAnalysis {
  propertyName: string;
  analysisDate: string;
  dateRangeStart: string;
  dateRangeEnd: string;
  totalDates: number;
  totalCalendarDays: number;
  inParityCount: number;
  outOfParityCount: number;
  parityScore: number;
  parityRating: 'GOOD' | 'FAIR' | 'POOR' | 'CRITICAL';
  avgPriceDiff: number;
  avgPriceDiffPct: number;
  worstCompetitor: string;
  competitorCheapestCounts: Record<string, number>;
  severityCounts: Record<string, number>;
  dateRanges: DateRange[];
  dailyDetail: DailyRow[];
  otaCharts: OtaChartData[];
  leColumn: string;
  numCompetitors: number;
  yMin: number;
  yMax: number;
}
